import { render, staticRenderFns } from "./CreateShopForm.vue?vue&type=template&id=1f4e388d"
import script from "./CreateShopForm.vue?vue&type=script&lang=js"
export * from "./CreateShopForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports